import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EscritoVersionDto } from '@models/escritoVersion/escritoVersionDto.model';
import { CreateEscritoVersionRequest } from '@models/escritoVersion/createEscritoVersionRequest.model';

@Injectable({
  providedIn: 'root'
})
export class EscritoVersionService {


  private readonly baseUrl = '/api/EscritoVersion';

  constructor(private http: HttpClient) {}

  obtenerVersionesPorEscrito(idEscrito: number): Observable<EscritoVersionDto[]> {
    return this.http.get<EscritoVersionDto[]>(`${this.baseUrl}/ObtenerVersionesPorEscrito?idEscrito=${idEscrito}`);
  }

  buscarVersionesPorContenido(searchTerm: string): Observable<EscritoVersionDto[]> {
    return this.http.get<EscritoVersionDto[]>(`${this.baseUrl}/BuscarVersionesPorContenido?searchTerm=${searchTerm}`);
  }

  create(request: CreateEscritoVersionRequest): Observable<EscritoVersionDto> {
    return this.http.post<EscritoVersionDto>(`${this.baseUrl}/Create`, request);
  }

  restaurarVersion(idVersion: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/RestaurarVersion`, { idVersion });
  }

  eliminarNVersionesAntiguas(idEscrito: number, mantenerVersiones: number = 5): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/EliminarNVersionesAntiguas`, {
      idEscrito,
      mantenerVersiones
    });
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/Delete?id=${id}`);
  }

}
